import React, { useState } from 'react';
import { Button, Drawer, Form, InputNumber, message } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import LocationPicker from '@/components/locationpicker';
import { coordinatePair } from '@/utils/coordinates';
import './index.scss';
import NearbyHeatmap from './NearbyHeatmap';

const NearbyLocationSettings = ({ initialPosition, isMobile, navigation, renderNavigation, posts, loading, onQuery, onClear, onBusyChange }) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [mapVisible, setMapVisible] = useState(false);
  const [locating, setLocating] = useState(false);
  const [heatmap, setHeatmap] = useState([]);
  const radius = Form.useWatch('radius_km', form);
  const latitude = Form.useWatch('latitude', form); const longitude = Form.useWatch('longitude', form);
  const validatePosition = () => coordinatePair(form.getFieldValue('longitude'), form.getFieldValue('latitude'))
    ? Promise.resolve() : Promise.reject(new Error('请先搜索并选择地点、在地图上选点或使用当前位置'));
  const trigger = <Button icon={<EnvironmentOutlined />} aria-label="位置设置" onClick={() => setOpen(true)}>
    {!isMobile && '位置设置'}
  </Button>;

  return <>
    {renderNavigation ? renderNavigation(trigger) : <div className="nearby-location-navigation">
      {navigation ? React.cloneElement(navigation, { tabBarExtraContent: trigger }) : trigger}
    </div>}
    <Drawer title="附近招募位置设置" placement="right" size={isMobile ? '100%' : 560} className="nearby-location-drawer"
      forceRender open={open} onClose={() => setOpen(false)} afterOpenChange={setMapVisible}
      footer={<Button type="primary" block loading={loading} disabled={locating} onClick={() => form.submit()}>查找附近招募</Button>}>
      <Form form={form} layout="vertical" initialValues={{ radius_km: 5, ...initialPosition }} onValuesChange={onClear} onFinish={values => {
        if (!locating) { onQuery(values); setOpen(false); }
      }} onFinishFailed={({ errorFields }) => {
        if (errorFields.some(field => ['latitude', 'longitude'].includes(field.name[0]))) message.warning('请先搜索并选择地点、在地图上选点或使用当前位置');
      }}>
        <LocationPicker autoLocate={!initialPosition} latitude={latitude} longitude={longitude} posts={posts} heatmap={heatmap} showMap={mapVisible} onBusyChange={value => {
          setLocating(value); onBusyChange(value);
        }} onChange={(values, { automatic = false } = {}) => {
          if (automatic && initialPosition) return;
          onClear();
          form.setFieldsValue({ latitude: values.latitude, longitude: values.longitude });
          if (automatic && coordinatePair(values.longitude, values.latitude)) {
            onQuery({ latitude: values.latitude, longitude: values.longitude, radius_km: form.getFieldValue('radius_km') });
          }
        }} />
        <Form.Item name="radius_km" label="范围（公里）" rules={[{ required: true }]}><InputNumber min={0.5} max={100} precision={2} /></Form.Item>
        <Form.Item name="latitude" hidden rules={[{ validator: validatePosition }]}><InputNumber /></Form.Item>
        <Form.Item name="longitude" hidden rules={[{ validator: validatePosition }]}><InputNumber /></Form.Item>
        <p className="nearby-location-hint">进入页面会自动尝试定位并查找附近招募，查询位置不会自动写入个人资料或帖子。</p>
        <NearbyHeatmap visible={mapVisible} latitude={latitude} longitude={longitude} radius={radius} onData={setHeatmap} />
      </Form>
    </Drawer>
  </>;
};

export default NearbyLocationSettings;
